<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Generate One Time Payment</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-currency-input label="Amount" placeholder="Enter amount" :int-value.sync="amountInt" v-model="amount" required :rules="rules" />
        <base-text-field label="Description" placeholder="Enter description" v-model="description" class="tw-mb-6" />
        <base-email-field label="Email" placeholder="Enter email" required v-model="email" class="tw-mb-6" />
        <credit-card :business-id="businessId" />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="submit" :loading="isLoading" :disabled="!isFormValid" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Submit</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import CreditCard from "@/components/CreditCardv2/CreditCard";
import EventBus from "@/utils/global-events.js";

export default {
  components: {
    CreditCard,
  },
  props: {
    businessId: String,
    customerId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      amount: null,
      amountInt: null,
      description: "One time payment",
      email: "",
      rules: [() => this.amountInt > 50 || "Value must be greater than $0.50"],
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async submit() {
      if (!this.$refs.form.validate()) return;

      try {
        this.isLoading = true;
        const response = await this.$axios.post(`/businesses/${this.businessId}/charge`, {
          amount: this.amountInt,
          currency: "usd",
          description: this.description,
          email: this.email,
          customerId: this.customerId,
        });
        if (response.status == 200) {
          EventBus.$emit("GLOBAL_NOTIFY", { title: "Payment Succeeded", message: "Payment Succeeded" });
          this.errors = null;
        } else {
          EventBus.$emit("GLOBAL_NOTIFY", { title: "Payment Failed", message: "Payment Failed" });
          this.isLoading = false;
          this.errors = [{ message: response.status }];
        }
        this.$emit("new-payment");
        this.hide();
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
